import { render, staticRenderFns } from "./RatioDailyMonthlyUsers.vue?vue&type=template&id=10c1390e&"
import script from "./RatioDailyMonthlyUsers.vue?vue&type=script&lang=js&"
export * from "./RatioDailyMonthlyUsers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VPagination } from 'vuetify/lib/components/VPagination';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
installComponents(component, {VPagination,VProgressCircular})
